/**
 * MapLibre GL v6 er ESM-only og laster web-workeren fra en EGEN fil ved
 * kjøretid. Bundlere kan ikke skrive om den URL-en automatisk, så i en
 * produksjonsbygg peker workeren på en fil som ikke finnes (/assets/
 * maplibre-gl-worker.mjs → 404) og INGEN kart rendres.
 *
 * Fiksen (dokumentert av MapLibre): la Vite emittere workeren som en asset
 * via `?worker&url`, og fortell MapLibre hvor den ligger med setWorkerUrl()
 * FØR første kart opprettes.
 *
 * Importer denne modulen øverst i hvert entry point (før new Map()).
 */
import { setWorkerUrl } from 'maplibre-gl';
import workerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

setWorkerUrl(workerUrl);
